<table class="table w-100 mat-mdc-table mdc-data-table__table"
    [class.no-results]="showNoResults"
>
    <thead>
        <tr class="mat-mdc-header-row mdc-data-table__header-row">
            <th class="mat-mdc-header-cell mdc-data-table__header-cell" scope="col">
                {{ 'users.nameLabel' | translate }}
            </th>

            <th class="mat-mdc-header-cell mdc-data-table__header-cell" scope="col">
                {{ 'users.emailLabel' | translate }}
            </th>

            <th class="mat-mdc-header-cell mdc-data-table__header-cell" scope="col">
                {{ 'users.userRoleLabel' | translate }}
            </th>

            <th class="mat-mdc-header-cell mdc-data-table__header-cell" *ngIf="entity!=entities.Business" scope="col">
                {{ 'users.userBusinessLabel' | translate }}
            </th>

            <th class="mat-mdc-header-cell mdc-data-table__header-cell" *ngIf="showReseller" scope="col">
                {{ 'users.userResellerLabel' | translate }}
            </th>

            <th class="mat-mdc-header-cell mdc-data-table__header-cell" scope="col">
                {{ 'sent-invitations.state' | translate }}
            </th>

            <th class="mat-mdc-header-cell mdc-data-table__header-cell" scope="col">
                {{ 'sent-invitations.updatedLabel' | translate }}
            </th>

            <th class="mat-mdc-header-cell mdc-data-table__header-cell" scope="col">
                {{ 'sent-invitations.createdLabel' | translate }}
            </th>

            <th class="mat-mdc-header-cell mdc-data-table__header-cell text-center" scope="col">
                {{ 'sent-invitations.actions' | translate }}
            </th>
        </tr>
    </thead>

    <tbody class="mdc-data-table__content">
        <tr class="mat-mdc-row mdc-data-table__row" *ngFor="let item of users; index as i">
            <td class="mat-mdc-cell mdc-data-table__cell">
                <ngb-highlight [result]="item.user.firstName + ' ' + item.user.lastName"></ngb-highlight>
            </td>

            <td class="mat-mdc-cell mdc-data-table__cell email-cell">
                <ngb-highlight [result]="item.user.email"></ngb-highlight>
            </td>

            <td class="mat-mdc-cell mdc-data-table__cell">
                <div *ngxPermissionsOnly="['changeUserRoleAtBusiness','changeRoleToAnyUsers', 'changeUserRoleAtReseller']">
                    <div *ngIf="((loggedUser$ | async).role.name != roleEnum.UserBusiness) && (loggedUser$ | async).id != item.user.id">
                        <p-dropdown 
                            [options]="(item.role.name == roleEnum.BusinessAdmin) || (item.role.name == roleEnum.UserBusiness) ? (businessRoles$ | async) : (resellerRoles$ | async)" 
                            [(ngModel)]="item.role" 
                            optionLabel="labelName"
                            [showClear]="false" 
                            [immutable]="false"
                            appendTo="body"
                            (onChange)="(item.role.name == roleEnum.BusinessAdmin) || (item.role.name == roleEnum.UserBusiness) ? businessRoleChange.emit(item) : resellerRoleChange(item)">
                        </p-dropdown>
                    </div>
                </div>

                <div *ngIf="(loggedUser$ | async).id == item.user.id || (!permissions.changeUserRoleAtBusiness && !permissions.changeRoleToAnyUsers && !permissions.changeUserRoleAtReseller)">
                    {{item.role.labelName}}
                </div>

            </td>

            <td class="mat-mdc-cell mdc-data-table__cell" *ngIf="entity!=entities.Business">
                <ngb-highlight [result]="item?.business?.name"></ngb-highlight>
            </td>

            <td class="mat-mdc-cell mdc-data-table__cell" *ngIf="showReseller">
                <ngb-highlight [result]="item.business?.resellerName"></ngb-highlight>
            </td>

            <td class="mat-mdc-cell mdc-data-table__cell state-cell">
                <label *ngIf="item.invitationState == 'INVITED'" class="badge text-bg-primary">
                    Invited
                </label>

                <label *ngIf="item.invitationState == 'ACCEPTED'" class="badge text-bg-success">
                    Accepted
                </label>
            </td>

            <td class="mat-mdc-cell mdc-data-table__cell">
                {{ item.user.updatedAt | date: 'short' }}
            </td>

            <td class="mat-mdc-cell mdc-data-table__cell">
                {{ item.user.createdAt | date: 'short' }}
            </td>

            <td class="mat-mdc-cell mdc-data-table__cell actions-cell">
                <div class="actions-column">
                    <ng-container *ngxPermissionsOnly="['resendinvitationWithRoleToBusiness',resendInvitationOnReseller]">
                        <button
                            *ngIf="item.invitationState !== 'ACCEPTED'"
                            class="btn btn-borderless p-0 px-1"
                            ngbTooltip="Resend"
                            type="button"
                            (click)="resend.emit(item.user)"
                        >
                            <icon-plane />
                        </button>        
                    </ng-container>

                    <ng-container *ngxPermissionsOnly="['editUserOnBusiness','editUserFromAllUsers','editUserOnReseller']">
                        <button
                            *ngIf="item.user.id !== loggedUser.id"
                            class="btn btn-borderless p-0 px-1"
                            ngbTooltip="Edit"
                            type="button"
                            (click)="editUser(item.user)"
                        >
                            <icon-edit />
                        </button>
                    </ng-container>

                    <ng-container *ngxPermissionsOnly="['deleteUserOnBusiness','deleteUsersFromAllUsers','delet5eUserOnReseller']">
                        <button 
                            *ngIf="item.user.id !== loggedUser.id"
                            class="btn btn-borderless p-0 px-1"
                            ngbTooltip="Delete"
                            type="button"
                            (click)="deleteUser(item.user)"
                        >
                            <icon-delete />
                        </button>
                    </ng-container>
                </div>
            </td>
        </tr>
    </tbody>
</table>

<no-results *ngIf="showNoResults" />

